"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSearchUrl = void 0;
const getSearchUrl = name => `/search?query=${encodeURIComponent(name)}`;
exports.getSearchUrl = getSearchUrl;